import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import { theme } from "../../../../theme";
import { StyledInputTitle } from "../../styles";

interface Props {
  title: React.ReactNode;
  isOptional?: true;
  hasLine?: boolean;
  alignStart?: true;
  margin?: string;
  children?: any;
}
const InputWrapper: React.ForwardRefExoticComponent<
  Props & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, Props>(
  (
    { alignStart, isOptional, hasLine = true, title, children, margin },
    ref
  ) => {
    return (
      <StyledInputWrapper ref={ref} margin={margin} alignStart={alignStart}>
        <Row gutter={[0, 16]} style={{ width: "100%" }} wrap={false}>
          <Col flex="0 0 180px" style={{ height: "32px" }}>
            <StyledInputTitle>
              {title} {!isOptional && <RequiredStar>*</RequiredStar>}
            </StyledInputTitle>
          </Col>
          <Col flex="0 1 100%">
            <Row>
              <Col span={24}>
                <StyledInputContent>{children}</StyledInputContent>
              </Col>
              {hasLine && (
                <Col span={24}>
                  <StyledLine />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </StyledInputWrapper>
    );
  }
);
export default InputWrapper;
const StyledInputWrapper = styled.div<{ margin?: string; alignStart?: true }>`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: ${({ alignStart }) => (alignStart ? "flex-start" : "center")};

  min-height: 32px;
`;

const StyledInputContent = styled.div`
  width: 100%;
`;

const RequiredStar = styled.div`
  color: ${theme.colors.red3};
  margin-left: 4px;
  line-height: 24px;
`;
const StyledLine = styled.div`
  border: 1px solid ${theme.colors.gray7};
  width: 100%;
  margin: 32px 0px;
`;
